import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  styled,
  Fab,
  Stack,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from 'react-router-dom';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';
import { apigetPublic } from '../../service/api';

const DashboardContainer = styled(Container)(() => ({
  paddingTop: '100px',
  paddingBottom: '50px',
}));

const BranchCard = styled(Card)(({ theme }) => ({
  height: '100%',
  boxShadow: theme.shadows[3],
  borderRadius: '16px',
  overflow: 'hidden',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: theme.shadows[6],
  },
}));

const BranchLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));

const BranchImage = styled(CardMedia)(() => ({
  height: 180,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export default function BranchDashboard() {
  const [branches, setBranches] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBranches = async () => {
      const result = await apigetPublic('branches/search'); // adjust backend route if needed
      if (result?.status === 200 && Array.isArray(result.data?.result)) {
        setBranches(result.data.result);
      }
      setIsLoading(false);
    };
    fetchBranches();
  }, []);

  return (
    <>
      <LandingPageNav />

      <Box
        sx={{
          backgroundImage: 'url(/assets/backgroundimageforherobanner.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          pt: 5,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(255,255,255,0.9)',
            minHeight: '100vh',
            position: 'relative',
          }}
        >
          <DashboardContainer>
            <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
              Branch Dashboard
            </Typography>

            {isLoading ? (
              <Typography align="center">Loading branches...</Typography>
            ) : branches.length > 0 ? (
              <Grid container spacing={4}>
                {branches.map((branch) => (
                  <Grid item xs={12} sm={6} md={4} key={branch._id}>
                    <BranchLink to={`/dashboard/branches/${branch._id}`}>
                      <BranchCard>
                        
                      {/* Branch Image */}
  <BranchImage
    image={
      branch.branchImageUrl
        ? branch.branchImageUrl.startsWith("http")
          ? branch.branchImageUrl
          : `https://${branch.branchImageUrl.replace(/^https?:\/\//, "")}`
        : "/assets/images/no-image.jpg"
    }
  />

                        <CardContent>
                          <Typography variant="h5" sx={{ mb: 1 }}>
                            {branch.name}
                          </Typography>

                          <Typography variant="body1" color="text.secondary">
                            {branch.city}, {branch.stateCode}
                          </Typography>

                          <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
                            {branch.address}
                          </Typography>

                          <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
                            Loan Officers: {branch.loanOfficers?.length || 0}
                          </Typography>
                        </CardContent>

                       
                      </BranchCard>
                    </BranchLink>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography align="center" sx={{ mt: 4 }}>
                No branches found.
              </Typography>
            )}
          </DashboardContainer>

          {/* Floating Create Button */}
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => navigate('/dashboard/branches/create')}
            sx={{
              position: 'fixed',
              bottom: 32,
              right: 32,
              backgroundColor: '#1976d2',
              '&:hover': { backgroundColor: '#115293' },
            }}
          >
            <AddIcon />
          </Fab>
        </Box>
      </Box>

      <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
      <Footer />
    </>
  );
}
